import React, { useState, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppContext } from '../../contexts';
import Card from '../../components/elements/Card';
import Button from '../../components/elements/Button';
import Text from '../../components/fields/Text';
import IconAdd from '../../components/icons/IconAdd';
import styles from './styles.scoped.css';
import ScrollToTop from '../../components/elements/ScrollToTop';
import DataTable from '../../components/elements/DataTable';
import IconPencil from '../../components/icons/IconPencil';
import { useDebounce } from '../../utils/hooks';
import { fetchPermissionUser, createPermission, editPermission } from './actions';
import FormPermission from '../../components/forms/PermissionForm';
import { ActionIcon, Modal } from '@mantine/core';

export default function Permission() {
  const { setBreadcrumbs } = useContext(AppContext);
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const [modalForm, setModalForm] = useState(false);
  const [detail, setDetail] = useState({});
  const { dataPermission, isLoadingPermission,
    isLoadingSubmitPermission,
    isLoadingSubmitUpdatePermission } = useSelector((state) => state.permission);
  const { data, meta } = dataPermission;
  const debouncedSearch = useDebounce(search, 500);

  const renderPathDisplay = (value) => {
    return <span className={styles.path}>{value}</span>;
  };
  const handleEditData = (value) => {
    setDetail({ permission: value.name, path: value.path, permissionId: value.permitionId });
    setModalForm(true);
  };

  const renderActionDisplay = (value) => {
    return (
      <div className={styles.actionContainer}>
        <ActionIcon
          onClick={() => handleEditData(value)}
          title={'Edit'}
        >
          <IconPencil style={{ fill: 'white' }} />
        </ActionIcon>
      </div>);
  };

  const column = [
    { heading: 'Nama', value: 'name', className: '' },
    {
      heading: 'Path URL',
      value: (value) => renderPathDisplay(value.path),
      className: ''
    },
    {
      heading: 'Action',
      value: (value) => renderActionDisplay(value),
      className: '',
    },
  ];

  const handleOpenModalForm = () => {
    setDetail({});
    setModalForm(true);
  };
  const handleSubmit = (payload) => {
    if (Object.keys(detail).length === 0) {
      dispatch(createPermission(payload));
    } else {
      dispatch(editPermission(payload));
    }
    setModalForm(false);
  };
  const fetchListPermissionUser = (scrollId) => {
    dispatch(fetchPermissionUser(scrollId, search));
  };
  useEffect(() => {
    setBreadcrumbs(['Permission']);
  }, []);

  useEffect(() => {
    fetchListPermissionUser();
  }, [debouncedSearch, isLoadingSubmitPermission, isLoadingSubmitUpdatePermission]);

  return (
    <div className={styles.root}>
      <Card className={styles.toolBox}>
        <Button
          className={styles.button}
          onClick={() => handleOpenModalForm()}
        >
          <IconAdd style={{ fill: '#FFFFFF' }} />
          <span>Tambah Permission</span>
        </Button>
        <form className={styles.searchForm}>
          <Text
            hideLabel
            inputProps={{
              placeholder: 'Cari data...',
              value: search,
              icon: 'ic-search.svg',
              onChange: (e) => setSearch(e.target.value),
            }}
          />
        </form>
      </Card>
      <Card>
        <div className={styles['table-container']}>
          <DataTable
            className={styles.table}
            column={column}
            data={data}
            endTreshould={500}
            loading={isLoadingPermission}
            meta={meta}
            onEndReached={() => fetchListPermissionUser(meta.page)}
            onRefresh={fetchListPermissionUser}
            withIndex
          />
        </div>
      </Card>
      <ScrollToTop />
      <Modal centered onClose={() => setModalForm(false)} opened={modalForm}
        size="lg"
        withCloseButton={false}
      >
        <FormPermission initialValues={detail} onSubmit={handleSubmit} />
      </Modal>
    </div>
  );
}
